module.exports = __webpack_public_path__ + "static/media/blackalo50.d92ccac4.png";